import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import PlayerService from 'services/Streaming/PlayerService';
import FirebaseStore from 'stores/FirebaseStore';
import StreamingStore from 'stores/StreamingStore';
import UserStore from 'stores/UserStore';
import allUserGroups from 'enum/userGroups';

import styles from './VideoMetrics.css';


const VideoMetrics = (props) => {
  const { isWebrtc, isBroadcaster } = props;
  const { videoMetrics } = PlayerService;
  const { isStreamingSaas, streamingProvider } = FirebaseStore;
  const { broadcastId } = StreamingStore;
  const { hasCF } = UserStore;

  return (
    <div className={isBroadcaster ? styles.videoBroadcasterMetricsWrapper : styles.videoMetricsWrapper}>
      <ul>
        <li>
          Resolution: {videoMetrics.resolution}@{videoMetrics.viewerFps} fps
        </li>
        {isWebrtc && isBroadcaster ? (
          <li>Bitrate: {videoMetrics.broadcasterBitrate}</li>
        ) : (
          <li>
            Bitrate: Min: {videoMetrics.minBitrate * 8} Kbps, Current: {videoMetrics.viewerBR * 8} Kbps, Max:{' '}
            {videoMetrics.maxBitrate * 8} Kbps
          </li>
        )}
        {!isWebrtc && (
          <Fragment>
            <li>Estimated Bandwidth: {videoMetrics.mbr * 8} Kbps</li>
            <li>Dropped Frames: {videoMetrics.viewerDropFps}</li>
          </Fragment>
        )}
        {!isBroadcaster && (
          <Fragment>
            <li>
              Viewport {videoMetrics.width}x{videoMetrics.height}
            </li>
            <li>Delay: {videoMetrics.delay + Math.round(videoMetrics.bfl)} seconds</li>
          </Fragment>
        )}
        {!isWebrtc && <li>Buffer Length: {videoMetrics.bfl && videoMetrics.bfl.toFixed(2)} seconds</li>}
        {isBroadcaster && !broadcastId ? (
          <li>Streaming Provider: {isWebrtc && hasCF(allUserGroups.STREAMING_SAAS) ? 'CEEBLUE' : 'WOWZA'}</li>
        ) : (
          <li>Streaming Provider: {isStreamingSaas ? streamingProvider : 'WOWZA'}</li>
        )}
      </ul>
    </div>
  );
};

VideoMetrics.defaultProps = {
  isBroadcaster: false,
  isWebrtc: false,
};

VideoMetrics.propTypes = {
  isBroadcaster: PropTypes.bool,
  isWebrtc: PropTypes.bool,
};

export default observer(VideoMetrics);
